import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { BiTranslatePipe } from "@globals/bi-translate";
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { HtmlSanitizePipe } from "../../pipes/bi-html-sanitize.pipe";

/**
 * Component that wraps a Prime Ng ConfirmDialog. Only ONE can exist at a time.
 */
@Component({
  selector: "bi-confirm-dialog",
  imports: [ButtonModule, ConfirmDialogModule, HtmlSanitizePipe, BiTranslatePipe],
  templateUrl: "./bi-confirm-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BiConfirmDialogComponent {
  protected readonly confirmationService = inject(ConfirmationService);
}
